export default class FasciaSignupEventoLondraFSS {
    constructor(node) {
        this.node = node;
        this.formNode = node.querySelector('form');
        
        this.settings = window.fasciaSignupEventoLondraFSS;
        
        this.addListeners();
    }

    static init() {
        let fasciaNode = document.querySelector("[data-fascia-signup-evento-londra-fss]");

        if (fasciaNode) {
            return new FasciaSignupEventoLondraFSS(fasciaNode);
        }
    }
    
    addListeners() {
        let _this = this;

        $(this.formNode).validate({
            callbackHandler: function (data, form)
            {
                _this.formNode.querySelector('.response-text').innerHTML = data.d.HTML;
                if (data.d.Status)
                    _this.formNode.querySelector('input[type="submit"]').style.display = 'none';
            }
        });
    }
}